import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { addToObject, removeFromObject } from '../../utils/immutable';
import DropDown from './DropDown';

class DropDownGroup extends Component {
  constructor(props) {
    super(props);

    props.setPartialCreditValidator(this.partialCreditValidator);
    props.setReviewSheet(this.renderReviewChunk);
  }

  getInput = label => {
    const { input } = this.props;
    if (input && label in input) {
      return input[label];
    }
    return null;
  };

  handleChange = (label, value) => {
    const { input } = this.props;
    const payload = value
      ? addToObject(input, label, value)
      : removeFromObject(input, label);
    this.props.onInput(payload);
    const readyToSubmit =
      Object.keys(payload).length === this.props.data.questions.length;
    this.props.setSubmitStatus(readyToSubmit);
  };

  partialCreditValidator = (input, correctInput) => {
    let incorrectSelections = 0;

    Object.keys(correctInput).forEach(prompt => {
      if (correctInput[prompt] !== input[prompt]) {
        incorrectSelections++;
      }
    });

    return incorrectSelections < 2;
  };

  renderReviewChunk = () => {
    const { question, data, correctInput } = this.props;
    return (
      <Fragment>
        <p className="review-question">{question}</p>
        {data.questions.map(question => {
          return (
            <div key={question.label}>
              <p className="review-option">
                {question.label} [
                {question.options.map((option, index) => {
                  if (index === question.options.length - 1) {
                    return <span key={option}>{option}</span>;
                  } else {
                    return <span key={option}>{option}, </span>;
                  }
                })}
                ]
              </p>
              <p className="review-correct">
                Correct Answer: {correctInput[question.label]}
              </p>
            </div>
          );
        })}
      </Fragment>
    );
  };

  render() {
    const { data } = this.props;
    return (
      <Fragment>
        {data.question && <h3>{data.question}</h3>}
        {this.props.data.questions.map((selectData, index) => {
          return (
            <DropDown
              key={index}
              data={selectData}
              placeholder={data.placeholderText}
              correctInput={this.props.correctInput[selectData.label]}
              isValidated={this.props.validationResult !== null}
              input={this.getInput(selectData.label)}
              onChange={this.handleChange}
              isFinalAttempt={this.props.isFinalAttempt}
            />
          );
        })}
      </Fragment>
    );
  }
}

DropDownGroup.defaultProps = {
  input: {},
  correctInput: null
};

DropDownGroup.propTypes = {
  data: PropTypes.array.isRequired,
  input: PropTypes.object,
  correctInput: PropTypes.object,
  onInput: PropTypes.func.isRequired
};

export default DropDownGroup;



// WEBPACK FOOTER //
// ../core/src/components/Dropdown/DropDownGroup.js